"use client";

import { PromotionProgressBar } from "@pamperedchef/consumer-components/cart";

import { ErrorBoundary } from "@/app/components/shared/error-boundary";
import { usePromotionProgress } from "./use-promotion-progress";
import type { Locale } from "@/domain";

export interface PromotionProgressBarBlockProps {
	locale: Locale;
	currency: string;
}

function PromotionProgressBarContent({
	locale,
	currency
}: PromotionProgressBarBlockProps): JSX.Element | null {
	const promotionProgress = usePromotionProgress();

	if (!promotionProgress) return null;

	return (
		<PromotionProgressBar
			source="ATC"
			milestones={promotionProgress.milestones}
			progress={promotionProgress.progress}
			locale={locale}
			currency={currency}
		/>
	);
}

export function PromotionProgressBarBlock(
	props: PromotionProgressBarBlockProps
): JSX.Element {
	return (
		<ErrorBoundary componentId="promotion_progress_bar">
			<PromotionProgressBarContent {...props} />
		</ErrorBoundary>
	);
}
